<section class="banner">
    <div class="banner-half"></div>

    <div class="container">
        <div class="row">
            <div class="col-md-5">
                <h1>Your one-stop supplier shop.</h1>
                <p>Manage all your suppliers from one platform.
                    View Inventory and place orders in real time.</p>
                <!-- ww222 -->
                <a class="btn" routerLink="/login?signup=true">Start Now ></a>
            </div>
            <div class="col-md-7">
                <img src="/assets/img/portal-new.png" alt="banner" class="w-100">
            </div>
        </div>
    </div>
</section>

<!-- home -logo -->
<section class="home-logos feature d-none">
    <h2 class="home-title text-center">Industry Leading Brands Sell Through Clockwork.</h2>
    <div class="home-logos-wrap">
        <div class="new-home-logo">
            <a href="#">
                <img src="/assets/img/new-b-1.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-2.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-3.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-4.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-5.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-6.png"/>
            </a>
            <a href="#">
                <img src="/assets/img/new-b-7.png"/>
            </a>

        </div>
    </div>

</section>


<section class="three-images-box">
    <img src="/assets/img/three-images.png" class="w-100"/>
</section>


<section class="make-money-wrap" id="featureretailer">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="title-two text-center">Features that save time and make money.</h3>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4">
                <div class="money-box">
                    <span>
                        <img src="/assets/img/money1.svg"/>
                    </span>
                    <h4>Supplier Data</h4>
                    <p>Download and keep the most accurate product data and images from your suppliers whenever needed.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="money-box">
                    <span>
                        <img src="/assets/img/money2.svg"/>
                    </span>
                    <h4>Dropship with Ease</h4>
                    <p>Order and ship from the suppliers closest location to your customer. Reduce transit times and freight expenses.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="money-box">
                    <span>
                        <img src="/assets/img/money3.svg"/>
                    </span>
                    <h4>API Integration</h4>
                    <p>Integrate your suppliers live inventory
                        into your own POS System and/or
                        e-commerce website</p>
                </div>
            </div>

            <div class="col-md-4">
                <div class="money-box">
                    <span>
                        <img src="/assets/img/money4.png"/>
                    </span>
                    <h4>Live Inventory</h4>
                    <p>Gain instant visibility into real-time product availability, it's quantity and location.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="money-box">
                    <span>
                        <img src="/assets/img/money5.svg"/>
                    </span>
                    <h4>24/7 Online Ordering</h4>
                    <p>Order from your suppliers instantly at your wholesale prices through your personal portal.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="money-box">
                    <span>
                        <img src="/assets/img/money3.svg"/>
                    </span>
                    <h4>Customizable</h4>
                    <p>Add your logo, hide your cost price and show customers available options from your suppliers.</p>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="pricing-box" *ngIf="!isLoggedIn" id="pricing">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <!-- <h3 class="title-two text-center">Pricing.</h3> -->
      </div>
    </div>
  </div>

  <app-preloader *ngIf="isLoading"></app-preloader>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 col-lg-4" *ngFor="let plan of plans">
        <div class="popular-box" *ngIf="plan.is_popular">MOST POPULAR</div>
        <div class="pricing-box" [class.selected-box]="profileData?.plan_id === plan.id"
          [class.starter-box]="plan.slug.toLowerCase() === 'starter-plan'"
          [class.plus-box]="plan.slug.toLowerCase() === 'plus-plan'"
          [class.pre-box]="plan.slug.toLowerCase() === 'premium-plan'">
          <h5>{{ plan.name }}</h5>
          <span [innerHTML]="plan.description"></span>
          <ng-template [ngIf]="plan.price === 0">
            <h6>Free</h6>
            <button class="btn" (click)="purchase(plan)">Signup</button>
          </ng-template>
          <ng-template [ngIf]="plan.price > 0">
            <h6>{{ plan.price }} USD/Month</h6>
            <span>Billed Monthly</span>
            <button class="btn" (click)="purchase(plan)">Try for Free</button>
            <p>{{ plan.trial_days }} Days free trial- No credit card required</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="success-box">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="title-two text-center">All in one tool for success.</h3>
                <p>Access all your supplier data orders and inventory right from the web app on
                    any device.</p>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <img src="/assets/img/success-image.jpg" class="w-100"/>
            </div>
        </div>
    </div>
</section>
<app-getstarted></app-getstarted>
